/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { CategoryListSubCategoryResponse } from './CategoryListSubCategoryResponse';

export type CategoryListSubCategoryResponseApiRespoonse = {
    data?: CategoryListSubCategoryResponse;
    status?: CategoryListSubCategoryResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace CategoryListSubCategoryResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

